<template>
  <div class="promotion-apply">
    <div class="row">
      <div class="col-12">
        <div class="form-group" :class="['text-' + align]">
          <strong>
            <a data-target="#promotion-modal" data-toggle="modal" href="#">{{ $t('Promosyon Kodu Ekle') }}</a>
          </strong>
        </div>
        <h3 v-if="promotionCodes.length" class="main_question">
          {{ $t('Uygulanan promosyon kodları') }}
        </h3>
        <div class="mb-2">
          <div v-for="(promotion, index) in promotionCodes" :key="index" class="d-flex">
            <a
              href="javascript:;"
              class="delete-icon"
              v-tippy="$t('Promosyon kodunu kaldır')"
              @click="removePromotion(index)"
              ><i class="fa fa-times"></i
            ></a>
            <p class="ml-1 ml-2 mb-2 promo">{{ promotion }}</p>
          </div>
        </div>
      </div>
    </div>
    <PromotionModal
      ref="promotionModal"
      :companyType="companyType"
      :promotionCodes="promotionCodes"
      :form="form"
      @promotion="applyPromotion"
      :is-have-custom-endpoint="isHaveCustomEndpoint"
      @custom-apply-promotion-clicked="onCustomApplyPromotionClicked"
    />
  </div>
</template>

<script>
import PromotionModal from './modals/PromotionModal';
import payment from './../stores/payment.js';

export default {
  props: {
    companyType: {
      type: Object,
    },
    isHaveCustomEndpoint: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
    },
    companyId: {
      type: Number,
    },
    companyNationId: {
      type: Number,
    },
    discount: {
      type: Number,
    },
    align: {
      type: String,
      default: 'right',
    },
  },
  components: {
    PromotionModal,
  },
  data() {
    return {
      promotionCodes: [],
    };
  },
  methods: {
    setPromotionCodes(data) {
      this.promotionCodes = data;
      this.form.promotion_code = this.promotionCodes;
    },
    removePromotionCode(index) {
      this.promotionCodes = this.promotionCodes.filter((item) => item !== code);
    },
    onCustomApplyPromotionClicked(code) {
      this.$emit('custom-apply-promotion-clicked', code);
    },
    applyPromotion(products) {
      this.findTotalDiscount(products);
      this.form.promotion_code = this.promotionCodes;
      if (this.companyNationId === 1) {
        this.$emit('promotion-changed');
        this.$emit('update-products', { products: products });
      }
      this.$emit('call-intent');
    },
    removePromotion(index) {
      if (this.isHaveCustomEndpoint) {
        this.$emit('custom-remove-promotion-clicked', null, index);
      } else {
        const promotions = [...this.promotionCodes];

        promotions.splice(index, 1);

        payment
          .dispatch('multiplePromotionAppliable', {
            productId: this.form.product_id,
            promotions: promotions,
            companyTypeId: this.companyType.id,
          })
          .then((s) => {
            this.findTotalDiscount(s.data.data);
            this.promotionCodes.splice(index, 1);
            this.form.promotion_code = this.promotionCodes;
            if (this.companyNationId === 1) {
              this.$emit('promotion-changed');
              this.$emit('update-products', { products: s.data.data });
            }
            this.$emit('call-intent');
          });
      }
    },
    findTotalDiscount(products) {
      let totalDiscount = 0;
      if (this.companyNationId === 1) {
        products.forEach((product) => {
          totalDiscount += product.discount;
        });
      } else {
        products.forEach((product) => {
          totalDiscount += product.stripe_discount;
        });
      }

      this.$emit('update:discount', totalDiscount);
      return totalDiscount;
    },
  },
};
</script>

<style scoped>
#promotion-flex {
  gap: 1rem;
}
.delete-icon {
  position: relative;
  top: 2px;
  color: #ff0000;
}

.delete-icon:hover {
  color: #e60000;
}

.promo {
  font-size: 1rem;
}
</style>
